'use strict';

import Collection from './collection.js';
import ActionLog from 'newModels/action-log.js';
import axios from 'axios';

export default class ActionLogs extends Collection {
    url() {
        return '/ActionLogs';
    }

    initialize() {
        this.model = ActionLog;
        super.initialize(...arguments);

        this.pagination.offset = 0;
        this.pagination.limit = 10;
        this.pagination.page = 0;
        this.pagination.pages = 0;
        this.pagination.count = 0;

        this.options.sortKey = 'createdAt';
        this.options.sortOrder = 'descending';
        return this;
    }

    fetchForEmployee(employee, options = {limit: undefined, skip: undefined}) {
        return axios.get(
            this.finalUrl() + '/getOwnAndManaged/' + employee.id,
            {
                params: {
                    limit: options.limit || 10,
                    skip: options.skip
                },
                headers: {'Authorization': app.user.getAccessToken().id}
            }
        ).then(r => r.data.results)
        .then(results => {
            this.reset(results, {silent: true});

            // save some requests by setting information we already know
            // about (employee and user) whenever possible
            this.forEach(model => {
                if (model.get('employeeId') === employee.id) {
                    model.employee = employee;
                }
                if (model.get('userId') === app.user.id) {
                    model.user = app.user;
                }
            });
            this.trigger('sync');
            return this;
        });
    }

    fetchForCompany(company, options = {limit: undefined, skip: undefined}) {
        return axios.get(
            this.finalUrl() + '/getForCompany/' + company.id,
            {
                params: {
                    limit: options.limit || 10,
                    skip: options.skip
                },
                headers: {'Authorization': app.user.getAccessToken().id}
            }
        ).then(r => r.data.results)
        .then(results => {
            this.reset(results, {silent: true});
            // save some requests by setting information we already know
            // about (user) whenever possible
            this.forEach(model => {
                if (model.get('userId') === app.user.id) {
                    model.user = app.user;
                }
            });
            this.trigger('sync');
            return this;
        });
    }
}



// WEBPACK FOOTER //
// ./app/new-collections/action-logs.js